import React from 'react';
import Chip from '@material-ui/core/Chip';

const ConditionOptionsChipField = ({ record, source }) => {
  if (!record) {
    return null;
  }
  const types = record[source];
  if (!types) {
    return null;
  }
  types.sort();
  return types.map((item) => <Chip key={item} label={item} />);
};
ConditionOptionsChipField.defaultProps = {
  label: 'Condition Options',
  source: 'condition_options',
};

export default ConditionOptionsChipField;
